import { NotificationPreferencesDto, SetNotificationPreferencesDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';

const REQUEST_NOTIFICATION_PREFERENCES = '[Request][settings] notifications';
const RESPONSE_SUCCESS_NOTIFICATION_PREFERENCES = '[Response][Success][settings] notifications';
const RESPONSE_FAIL_NOTIFICATION_PREFERENCES = '[Response][Fail][settings] notifications';

const REQUEST_UPDATE_NOTIFICATION_PREFERENCES = '[Request][settings] update notifications';
const RESPONSE_SUCCESS_UPDATE_NOTIFICATION_PREFERENCES = '[Response][Success] update notifications';
const RESPONSE_FAIL_UPDATE_NOTIFICATION_PREFERENCES = '[Response][Fail] update notifications';

export const RequestNotificationPreferencesAction = createAction(REQUEST_NOTIFICATION_PREFERENCES);

export const RequestUpdateNotificationPreferencesAction = createAction(
  REQUEST_UPDATE_NOTIFICATION_PREFERENCES,
  props<{ payload: SetNotificationPreferencesDto }>()
);

export const ResponseSuccessUpdateNotificationPreferencesAction = createAction(
  RESPONSE_SUCCESS_UPDATE_NOTIFICATION_PREFERENCES,
  props<{ payload: NotificationPreferencesDto }>()
);

export const ResponseFailUpdateNotificationPreferencesAction = createAction(
  RESPONSE_FAIL_UPDATE_NOTIFICATION_PREFERENCES,
  props<{ payload: any }>()
);

export const ResponseSuccessNotificationPreferencesAction = createAction(
  RESPONSE_SUCCESS_NOTIFICATION_PREFERENCES,
  props<{ payload: NotificationPreferencesDto }>()
);

export const ResponseFailNotificationPreferencesAction = createAction(
  RESPONSE_FAIL_NOTIFICATION_PREFERENCES,
  props<{ payload: any }>()
);
